import { render, staticRenderFns } from "./TableExtendedRow.vue?vue&type=template&id=64dc9c3f&"
import script from "./TableExtendedRow.vue?vue&type=script&lang=js&"
export * from "./TableExtendedRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports